import React, {useEffect, useState} from 'react'
import ButtonContainer from '../Components/ButtonContainer';
import COLORS from '../Colors';
import '../Styles/StartEndScreen.css';
import { withRouter } from "react-router-dom";
import { CognitoHelper } from '../Utilities/CognitoHelper';
import { PATH_NAMES } from '../Utilities/Constants';
import * as api from '../Scripts/Api';

function Welcome(props) {
  useEffect(() => {
    document.body.style.height = '100%';
  }, []);

  const [counter, setCounter] = useState(0);

  sessionStorage.setItem('questionnaireIdx', 0);
  sessionStorage.setItem('testIdx', 0);
  sessionStorage.setItem('answers', JSON.stringify({}));

  var text = [
    <div>
      <h1 className='card-title'>Language</h1>
      <p className='card-text'>Please select your preferred language.</p>
    </div>,
  ]

  function clickNext(preferredLanguage) {
    //logout backdoor
    signOutBackdoor()
    console.log("counter is: " + counter);
    let currentTime = new Date().getTime()
    sessionStorage.setItem('startTime', currentTime);
    sessionStorage.setItem('preferredLanguage', preferredLanguage)
    api.record_prompt_response("language", preferredLanguage);
    setCounter(1)
    props.history.push({
      pathname: PATH_NAMES.WELCOME
    })
  }

  //TODO: remove when signout is no longer needed
  const signOutBackdoor = () => {
    if (sessionStorage.getItem('logout') === '1'){
      signOut();
    }
  }

  const signOut = () => {
    const cognitoHelper = new CognitoHelper()

    cognitoHelper.signOut(function() {
      console.log("signed out")
    })
  }

  return (
    <>
        <div className='card'>
          {text[counter]}
          <ButtonContainer
            colors={[COLORS.green]}
            buttonTexts={['Click here for English']}
            buttonType='empty'
            onClick={() => clickNext('EN')}
          />
          <ButtonContainer
            colors={[COLORS.green]}
            buttonTexts={['Haga clic aquí para Español']}
            buttonType='empty'
            onClick={() => clickNext('ES')}
          />
        </div>
      </>
  );
}

export default withRouter(Welcome);